import RegularText from '@/components/RegularText';
import { METHOD_OPTIONS } from '@/constants/enum';
import { Box, Icon, InlineStack, LegacyTabs } from '@shopify/polaris';
import { DeliveryIcon, GlobeAsiaIcon, StoreIcon } from '@shopify/polaris-icons';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PickupText } from './component/PickupText';
import { DeliveryText } from './component/DeliveryText';
import { ShippingText } from './component/ShippingText';

export const WidgetDesignTexts = () => {
  const { t } = useTranslation('widget_settings');
  const [selectedTab, setSelectedTab] = useState(METHOD_OPTIONS.PICKUP);

  const handleTabChange = useCallback((selectedTabIndex: number) => setSelectedTab(selectedTabIndex), []);

  const tabs = useMemo(
    () => [
      {
        id: 'widget-design-pickup',
        content: (
          <InlineStack gap={'200'} align="center">
            <Box>
              <Icon source={StoreIcon} />
            </Box>
            <RegularText fontWeight="medium">{t('widgetDesign.texts.method.0')}</RegularText>
          </InlineStack>
        ),
        panelID: 'widget-design-pickup',
      },
      {
        id: 'widget-design-delivery',
        content: (
          <InlineStack gap={'200'} align="center">
            <Box>
              <Icon source={DeliveryIcon} />
            </Box>
            <RegularText fontWeight="medium">{t('widgetDesign.texts.method.1')}</RegularText>
          </InlineStack>
        ),
        panelID: 'widget-design-delivery',
      },
      {
        id: 'widget-design-shipping',
        content: (
          <InlineStack gap={'200'} align="center">
            <Box>
              <Icon source={GlobeAsiaIcon} />
            </Box>
            <RegularText fontWeight="medium">{t('widgetDesign.texts.method.2')}</RegularText>
          </InlineStack>
        ),
        panelID: 'widget-design-shipping',
      },
    ],
    [t],
  );

  return (
    <Box>
      <LegacyTabs tabs={tabs} selected={selectedTab} onSelect={handleTabChange} fitted />
      <Box paddingBlockStart={'300'}>
        {selectedTab === METHOD_OPTIONS.PICKUP && <PickupText />}
        {selectedTab === METHOD_OPTIONS.DELIVERY && <DeliveryText />}
        {selectedTab === METHOD_OPTIONS.SHIPPING && <ShippingText />}
      </Box>
    </Box>
  );
};
